import React from 'react'
import Link from 'next/link'
import { Home, ArrowLeft } from 'lucide-react'
import { Button } from '~/components/ui/button'

const Page404 = () => {
    return (
        <div className='bg-background flex min-h-screen flex-col items-center justify-center px-4 py-16'>
            <div className='mx-auto max-w-md text-center'>
                <h1 className='text-foreground mb-4 text-6xl font-bold sm:text-7xl'>404</h1>

                <h2 className='text-foreground mb-3 text-2xl font-semibold sm:text-3xl'>Trang không tìm thấy</h2>

                <p className='text-muted-foreground mb-8'>
                    Rất tiếc, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển. Vui lòng kiểm tra lại đường
                    dẫn hoặc quay về trang chủ.
                </p>

                <div className='flex flex-col gap-3 sm:flex-row sm:justify-center'>
                    <Button asChild size='lg' className='w-full'>
                        <Link href='/'>
                            <Home className='h-4 w-4' />
                            Về trang chủ
                        </Link>
                    </Button>
                    <Button
                        variant='outline'
                        size='lg'
                        className='w-full'
                        onClick={() => window.history.back()}
                        type='button'
                    >
                        <ArrowLeft className='h-4 w-4' />
                        Quay lại
                    </Button>
                </div>

                <div className='border-border bg-muted/50 mt-8 rounded-lg border p-4 text-left'>
                    <p className='text-muted-foreground mt-2 text-sm'>
                        Có thể trang đã bị xóa, đổi tên hoặc đường dẫn không chính xác. Hãy thử tìm kiếm hoặc quay về
                        trang chủ.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Page404
